var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row flex-center q-mt-xl q-mb-xs"},[_c('div',{staticClass:"flex flex-center col-12"},[_c('img',{attrs:{"src":_vm.logo}})])])}
var staticRenderFns = []

export { render, staticRenderFns }